import { render, staticRenderFns } from "./SearchResultRow.vue?vue&type=template&id=36545b6b&scoped=true"
import script from "./SearchResultRow.vue?vue&type=script&lang=js"
export * from "./SearchResultRow.vue?vue&type=script&lang=js"
import style0 from "./SearchResultRow.vue?vue&type=style&index=0&id=36545b6b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36545b6b",
  null
  
)

export default component.exports